import NavBar from "./NavBar";


export default class NavBar_Hover extends NavBar {
	constructor(name, element) {
		super(name, element);
	}

	start() {
		this.slavesHasSub.forEach((item) => {
			this.bindEvents(item);
		});
	}

	bindEvents(element, allSubsArr, speed) {

		const subNav = element.querySelector(`[data-${this.componentName}-sub]`);
		const link = element.querySelector(`[data-${this.componentName}-link]`);

		if (!link) return false;

		element.addEventListener('mouseenter', () => {
			$(subNav).stop(true, false)[this.jqEffect.in](speed);
		});

		element.addEventListener('mouseleave', (e) => {
			if (!$.contains(element, e.target)) {
				$(subNav).stop(true, false)[this.jqEffect.out](speed);
			}
		});

	}
}
